module.exports = __webpack_public_path__ + "static/3-key-trends-for-the-transformational-year-ahead-3d2e0fec0367126549ee382c3fe70b73.png";